export default "__VITE_ASSET__CKfh8vrq__"